(function () {
  angular.module('kareo.ui.shared.directives.empty-state', [])
  .directive('emptyState',
     () => {
       return {
         template: require('./empty-state.pug')(),
         restrict: 'E',
         controller: emptyStateImgController,
         controllerAs: 'vm'
       };
     });

  function emptyStateImgController() {
    var vm = this;
    vm.emptyStateImgPath = '/shared-assets-ui/bundle/css/img/empty-state.png';
    vm.boldCaption = 'Nothing to see here.';
    vm.normalCaption = 'There are no items in the currently selected view.';
  }
})();
